/*
 * @Author: heyu tao
 * @since: 2021-11-17 09:45:31
 * @LastAuthor: CDS
 * @lastTime: 2022-07-20 16:28:13
 * @message: file content
 * @The path of the file relative to the project: /cds-portal-web/src/utils/fileDownload.js
 */

import { createRequest } from "../api/request"
import axios2 from "axios";
let axios = createRequest()
/**
 * 下载文件
 * @param {*} param0 
 * @returns 
 */
export default async function ({ url = "", name = '', type = '', params = {}, }) {
  let response = await axios.get(url, { responseType: "blob", params, });
  if (response.data.constructor != Blob) {
    return Promise.reject()
  }
  // 兼容IE11 
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(response.data, name)
  } else {
    let blob_url = window.URL.createObjectURL(response.data);
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = blob_url;
    link.setAttribute("download", name + type);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return Promise.resolve()
  }
}


// 将blob 块进行保存
export function saveBlob (b, name, type) {
  let blob_url = window.URL.createObjectURL(b);
  let link = document.createElement("a");
  link.style.display = "none";
  link.href = blob_url;
  link.setAttribute("download", name + type);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  return Promise.resolve()
}

// 请求接口，将blob块，返回为url
export async function ImgBlobUrl (url, params) {
  console.log(url,params)
  let response = await axios2.get(url, { responseType: "blob", params });
  console.log(response)
  if (response.data.constructor != Blob) {
    return Promise.reject()
  }
  // let blob_url = window.URL.createObjectURL(response.data);
  // return Promise.resolve(new Blob([response.data],{type:"image/pn"}))
  return Promise.resolve(response.data)
}
